import React from 'react';

const CheckMark = () => (
  <svg
    width="22"
    height="23"
    viewBox="0 0 22 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.0001 11.0799V11.9999C20.9975 16.4286 18.0824 20.3281 13.8354 21.5838C9.58847 22.8395 5.02145 21.1522 2.61101 17.437C0.200573 13.7217 0.52092 8.86353 3.39833 5.49696C6.27574 2.13039 11.0248 1.05741 15.0701 2.85989"
      stroke="#3448FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 4L11 14.01L8 11.01"
      stroke="#3448FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CheckMark;
